import React from "react"

import { ColGroup } from "./ColGroup"
import { TableBody } from "./TableBody"
import { TableHeader } from "./TableHeader"

/**
 * A a11y,responsive data grid
 */
export function Table() {
  return (
    <table role="grid">
      <ColGroup />
      <TableHeader />
      <TableBody />
    </table>
  )
}

Table.propTypes = {}
